import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import 'iconify-icon';

const Login = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user) navigate('/admin/dashboard', { replace: true });
  }, [user, navigate]);

  const formatError = (detail) => {
    if (!detail) return 'Algo deu errado. Tente novamente.';
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(' ');
    if (typeof detail?.msg === 'string') return detail.msg;
    return String(detail);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin/dashboard', { replace: true });
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-gradient-to-br from-neutral-900 to-neutral-700 flex items-center justify-center p-4 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-10 pointer-events-none"></div>
      <div className="max-w-md w-full relative z-10">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_b2005392-6212-4506-b62b-d5c77af4b77a/artifacts/n8p0qeqa_Logomarca_Horizontal_Preta.png"
            alt="IE Eneagrama"
            className="h-16 mx-auto mb-4 brightness-0 invert"
          />
          <h1 className="text-3xl font-bold text-white mb-2">Área Administrativa</h1>
          <p className="text-white/60">Faça login para gerenciar o conteúdo do site</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="glass-panel bg-white/10 backdrop-blur-xl p-8 rounded-2xl border border-white/20 space-y-5"
        >
          <div>
            <label className="block text-xs font-mono uppercase tracking-widest text-white/60 mb-2">Email</label>
            <input
              type="email"
              data-testid="admin-login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              placeholder="admin@ieneagrama.com.br"
              className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-sm text-white placeholder-white/40 outline-none focus:border-white/60 transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs font-mono uppercase tracking-widest text-white/60 mb-2">Senha</label>
            <input
              type="password"
              data-testid="admin-login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="••••••••"
              className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-sm text-white placeholder-white/40 outline-none focus:border-white/60 transition-colors"
            />
          </div>

          {error && (
            <div
              data-testid="admin-login-error"
              className="text-sm text-red-300 bg-red-500/10 border border-red-400/30 rounded-lg px-4 py-3"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            data-testid="admin-login-submit-btn"
            disabled={loading}
            className="w-full px-6 py-4 bg-white text-black rounded-lg font-medium hover:bg-neutral-100 transition-all transform hover:scale-[1.02] active:scale-95 flex items-center justify-center gap-3 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? (
              <>
                <span className="animate-spin h-4 w-4 border-2 border-black/30 border-t-black rounded-full"></span>
                <span>Entrando…</span>
              </>
            ) : (
              <>
                <iconify-icon icon="solar:login-3-linear" className="text-xl"></iconify-icon>
                <span>Entrar</span>
              </>
            )}
          </button>

          <div className="text-center text-xs text-white/40 pt-2">
            <p>Acesso restrito a administradores</p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
